///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { StaticContentDTO } from '../../../generated/shared-types.model';
import { ExtendedStaticContent, fromStaticContent } from '../models/extended-static-content.model';

@Injectable()
export class GtthStaticContentService {
    private readonly fetchUrl = 'api/static-content';
    private readonly modifyUrl = 'api/static-content';

    constructor(private readonly http: HttpClient) {}

    getContent(type: string): Observable<StaticContentDTO> {
        return this.http.get<StaticContentDTO>(`${this.fetchUrl}/${type}`);
    }

    getNoteItemContent(type: string): Observable<ExtendedStaticContent> {
        return this.http
            .get<StaticContentDTO>(`${this.fetchUrl}/${type}`)
            .pipe(map((content: StaticContentDTO) => fromStaticContent(content)));
    }

    save(content: StaticContentDTO): Observable<StaticContentDTO> {
        const copy: StaticContentDTO = { ...content };
        return this.http.post<StaticContentDTO>(this.modifyUrl, copy);
    }

    saveNoteItemContent(content: StaticContentDTO): Observable<ExtendedStaticContent> {
        const copy: StaticContentDTO = { ...content };
        return this.http.post<StaticContentDTO>(this.modifyUrl, copy).pipe(map((result: StaticContentDTO) => fromStaticContent(result)));
    }
}
